import { Icon } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import DenseAppBar from '../../components/AppBar';
import Filters from '../../components/Filters';
import PaginationControlled from '../../components/Pagination';
import Placeholder from '../../components/Skeleton';
import { getCurrency, getDateTime } from '../../helpers/Functions';
import { Reducers } from '../../Interfaces/Interfaces';
import { getTransactions, getTransactionSummary } from '../../redux/actions/TransactionActions';
import PrimaryTheme from '../../Themes/Primary';
import SimplePopover from '../Logs/LogViews';

export default function AggregatorTransactions() {
  const alert = useSelector((state: Reducers) => state.alert);
  const dashboard = useSelector((state: Reducers) => state.dashboard);
  const transactions = useSelector((state: Reducers) => state.transactions);

  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const params: any = useParams();

  const [searchState, setSearchState] = React.useState('');

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  let list = transactions && transactions.items;

  const filter = {};
  const paginationConfig = {
    page: page + 1,
    pageSize,
    id: params.id,
    whereCondition: JSON.stringify(filter)
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (item: any) => {
    setAnchorEl(null);

    console.log(item);

  };



  const getIndexSeed = (index: number) => {
    paginationConfig.page = page + 1;
    return (paginationConfig.page - 1) * paginationConfig.pageSize + index + 1;
  }

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handlePageSizeChange = (event: React.MouseEvent<HTMLButtonElement> | null, value: any) => {
    setPageSize(value.props.value);

    paginationConfig.pageSize = value.props.value;
    dispatch(getTransactions(paginationConfig));
  };

  const handleRefresh = () => {
    dispatch({
      type: 'LOADING',
      payload: true
    });
    dispatch(getTransactions(paginationConfig));
    dispatch(getTransactionSummary(params.id));
  }


  React.useEffect(() => {
    dispatch({
      type: 'LOADING',
      payload: true
    });

    dispatch(getTransactions(paginationConfig));
    dispatch(getTransactionSummary(params.id));

    return () => {
      dispatch({
        type: "TRANSACTIONS",
        payload: {}
      });
      dispatch({
        type: "DASHBOARD",
        payload: {}
      });
    }


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, page]);


  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: 'LOADING',
          payload: false
        })

        dispatch({
          type: 'ALERT',
          payload: {}
        });

      } else {

        handleRefresh();

        dispatch({
          type: 'LOADING',
          payload: false
        })

        dispatch({
          type: 'ALERT',
          payload: {}
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert, history]);
  const getId = (id: any) => {
    history.push(`/transactions/details/${id}`)
  }
  return (
    <React.Fragment>
      <div className="col-md-11 mr-auto ml-auto p-0" style={{
        height: 'auto',
        position: "relative",
      }}>
        <DenseAppBar
          onClick={() => history.goBack()}
          canGoBack
        />
      </div>
      <div className='col-md-12 pl-0 pr-0' style={{
        // overflow: "auto",
        backgroundColor: PrimaryTheme.white,
        // height: '100vh',
      }}>

        <div className="col-md-11 ml-auto mr-auto p-0" style={{
          backgroundColor: PrimaryTheme.white,
          height: '100vh',
          position: 'relative',
        }}>
          <h1 className="mb-5 transaction-agent-title" style={{
            fontFamily: PrimaryTheme.fonts?.MediumFont,
            textTransform: "uppercase",
            fontSize: PrimaryTheme.fontSizes?.subtitle
          }}>Aggregator {">"} Transactions</h1>

          {/* cards  */}
          <div className="row mb-5 small-subtitle" >
            <div className="col-md col-6" style={{
              height: 'auto',
              position: "relative",
            }}>
              <h5 className="text-uppercase" style={{
                color: PrimaryTheme.primary
              }}>Total</h5>
              <h3 className="text-uppercase text-bold mb-0" style={{
                color: PrimaryTheme.dark,
                fontFamily: PrimaryTheme.fonts?.MediumFont
              }}>{dashboard.totalTransactions ? dashboard.totalTransactions : 0}</h3>
              <h6 className="text-uppercase" style={{
                color: PrimaryTheme.primary,
              }}>{dashboard.transactionValue ? getCurrency(dashboard.transactionValue) : 0}</h6>
            </div>

            <div className="col-md col-6" style={{
              height: 'auto',
              position: "relative",
            }}>
              <h5 className="text-uppercase" style={{
                color: PrimaryTheme.primary
              }}>Transfers</h5>
              <h3 className="text-uppercase text-bold mb-0" style={{
                color: PrimaryTheme.dark,
                fontFamily: PrimaryTheme.fonts?.MediumFont
              }}>{dashboard.totalTransfers ? dashboard.totalTransfers : 0}</h3>
              <h6 className="text-uppercase" style={{
                color: PrimaryTheme.primary,
              }}>{dashboard.transferVolume ? getCurrency(dashboard.transferVolume) : 0}</h6>
            </div>

            <div className="col-md col-6" style={{
              height: 'auto',
              position: "relative",
            }}>
              <h5 className="text-uppercase" style={{
                color: PrimaryTheme.primary
              }}>Pos</h5>
              <h3 className="text-uppercase text-bold mb-0" style={{
                color: PrimaryTheme.dark,
                fontFamily: PrimaryTheme.fonts?.MediumFont
              }}>{dashboard.totalPosCashWithdrawal ? dashboard.totalPosCashWithdrawal : "0"}</h3>
              <h6 className="text-uppercase" style={{
                color: PrimaryTheme.primary,
              }}>{dashboard.posCashWithdrawalVolume ? getCurrency(dashboard.posCashWithdrawalVolume) : "0"}</h6>
            </div>

            <div className="col-md col-6" style={{
              height: 'auto',
              position: "relative",
            }}>
              <h5 className="text-uppercase" style={{
                color: PrimaryTheme.primary
              }}>Savings</h5>
              <h3 className="text-uppercase text-bold mb-0" style={{
                color: PrimaryTheme.dark,
                fontFamily: PrimaryTheme.fonts?.MediumFont
              }}>{dashboard.totalDeposit ? dashboard.totalDeposit : 0}</h3>
              <h6 className="text-uppercase" style={{
                color: PrimaryTheme.primary,
              }}>{dashboard.depositVolume ? getCurrency(dashboard.depositVolume) : 0}</h6>
            </div>

            <div className="col-md col-6" style={{
              height: 'auto',
              position: "relative",
            }}>
              <h5 className="text-uppercase" style={{
                color: PrimaryTheme.primary
              }}>Bills</h5>
              <h3 className="text-uppercase text-bold mb-0" style={{
                color: PrimaryTheme.dark,
                fontFamily: PrimaryTheme.fonts?.MediumFont
              }}>{dashboard.totalBillPayments ? dashboard.totalBillPayments : 0}</h3>
              <h6 className="text-uppercase" style={{
                color: PrimaryTheme.primary,
              }}>{dashboard.billPaymentVolume ? getCurrency(dashboard.billPaymentVolume) : 0}</h6>
            </div>

          </div>

          <div className="row mb-5">
            <div className="col-md-12">
              <Filters
                name="Download Transactions"
                hasDownloads
                hasSearch
                searchState={searchState}
                onClick={(e: any) => setSearchState(e.target.value)} />
            </div>
          </div>

          <div className="row " style={{ paddingBottom: "150px" }}>
            <div className="col-md-12 mb-3">
              {list ? (
                <React.Fragment>
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead className="thead-primary">
                        <tr className="text-center">
                          <th scope="col">S/N</th>
                          <th scope="col">Type</th>
                          <th scope="col">Date</th>
                          <th scope="col">Sender</th>
                          <th scope="col">Receiver</th>
                          <th scope="col">Amount</th>
                          <th scope="col">Status</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.length !== 0 && list?.map((item: any, index: number) => (
                          <tr key={index} className="text-center">
                            <th scope="row">{getIndexSeed(index)}</th>
                            <td >
                              <div className="row m-0 justify-content-start align-items-center">
                                {(item.transactionType === 1 || item.transactionType === 3) && <Icon fontSize="small" style={{
                                  color: PrimaryTheme.lightGreen,
                                  marginRight: 5
                                }}>fiber_manual_record</Icon>}
                                {item.transactionType === 4 && <Icon fontSize="small" style={{
                                  color: PrimaryTheme.lightGreen,
                                  marginRight: 5
                                }}>fiber_manual_record</Icon>}
                                {item.transactionType === 5 && <Icon fontSize="small" style={{
                                  color: PrimaryTheme.lightGreen,
                                  marginRight: 5
                                }}>fiber_manual_record</Icon>}
                                {item.transactionType === 2 && <Icon fontSize="small" style={{
                                  color: PrimaryTheme.info,
                                  marginRight: 5
                                }}>fiber_manual_record</Icon>}

                                {item.transactionType === 22 && <Icon fontSize="small" style={{
                                  color: PrimaryTheme.lightGreen,
                                  marginRight: 5
                                }}>fiber_manual_record</Icon>}
                                {item.transactionTypeName}
                              </div>
                            </td>
                            <td>{getDateTime(item.transactionDate)}</td>
                            <td>{item.sender}</td>
                            <td>{item.receiver}</td>
                            <td>{getCurrency(item.amount)}</td>
                            {/* <td>{item.aggregatorCommission ? getCurrency(item.aggregatorCommission) : "-"}</td> */}
                            <td>
                              {item.status === 1 && <span className="badge badge-pill badge-warning p-2 pl-3 pr-3 mr-1">{item.statusName}</span>}
                              {item.status === 2 && <span className="badge badge-pill badge-danger p-2 pl-3 pr-3 mr-1">{item.statusName}</span>}
                              {item.status === 3 && <span className="badge badge-pill badge-success p-2 pl-3 pr-3 mr-1">{item.statusName}</span>}

                              {/* <IconButton size="small" aria-controls={index + "simple-menu"} aria-haspopup="true" onClick={handleClick}>
                                <Icon style={{
                                  color: PrimaryTheme.light,
                                }}>more_vert</Icon>
                              </IconButton> */}

                              {/* <Menu
                                id={index + "simple-menu"}
                                anchorEl={anchorEl}
                                // keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                              >
                                <MenuItem onClick={() => history.push(`/transactions/details/${item.id}`)} style={{
                                  fontSize: 14
                                }}> <Icon fontSize="small" className="mr-2">visibility</Icon> View Details</MenuItem>
                                <MenuItem onClick={() => handleClose(item.id)} style={{
                                  fontSize: 14
                                }}> <Icon fontSize="small" className="mr-2">refresh</Icon> Reconfirm</MenuItem>
                              </Menu> */}

                            </td>
                            <td>
                              <SimplePopover popid={item.id} getId={getId} />
                            </td>

                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {list.length === 0 &&
                    <React.Fragment>
                      <p className='text-center mt-3 text-dark w-100'>No result</p>
                    </React.Fragment>

                  }

                  <div className='col-md-12 p-0'>
                    {transactions.total > pageSize && <PaginationControlled onPageSizeChange={handlePageSizeChange} onChange={handleChange} page={page} total={transactions.total && transactions.total} pageSize={pageSize} />}
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="col-md-12 text-center">
                    <Placeholder variant="text" width={'100%'} height={50} animation='wave' className="display-inline" />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder variant="text" width={'100%'} height={50} animation='wave' className="display-inline" />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder variant="text" width={'100%'} height={50} animation='wave' className="display-inline" />
                  </div>

                </React.Fragment>
              )}
            </div>
          </div>
        </div>

      </div>
    </React.Fragment>
  )
}
